import React from 'react'
import { useIntl } from 'react-intl'
import { FormElement, InputTextArea } from 'mailup-web-components'
import { messageState } from '../../recoil/state/message'
import { useRecoilState } from 'recoil'

// Notes: Maxlength=100

const InputNotes = () => {
  const intl = useIntl()
  const [{ notes }, setNotesState] = useRecoilState(messageState)

  const handleChangeNote = e => {
    e.stopPropagation()
    e.preventDefault()
    const value = e.target.value
    setNotesState(prev => ({
      ...prev,
      notes: value,
      isDirty: true
    }))
  }

  return (
    <FormElement
      labelFor='messageNote'
      label={intl.formatMessage({
        id: 'Load.SavedEmailWizard.LabelNotes'
      })}
    >
      <InputTextArea
        value={notes}
        onChange={handleChangeNote}
        maxLength='100'
        data-mu-test='input-note'
        placeholder={intl.formatMessage({
          id: 'Load.SavedEmailWizard.PlaceholderNotes'
        })}
      />
    </FormElement>
  )
}

export default InputNotes
